import React, { useEffect, useState } from 'react';
import ReactStars from 'react-rating-stars-component';
import styled from 'styled-components';

import Modal from '../../../Components/UI/Modal/Modal';
import { submitVerifiedReview } from '../../../Services/trustReviews';
import { getClientName } from '../../../Utils/legacyData';
import { useI18n } from '../../../i18n/I18nProvider';

const ReviewClientByArtisanModal = ({ show, close, demand }) => {
  const { t } = useI18n();
  const [rating, setRating] = useState(0);
  const [clarity, setClarity] = useState(0);
  const [responsiveness, setResponsiveness] = useState(0);
  const [paymentReliability, setPaymentReliability] = useState(0);
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) return;
    setRating(0); setClarity(0); setResponsiveness(0); setPaymentReliability(0); setComment(''); setError('');
  }, [show, demand?.demand_id]);

  if (!show || !demand) return null;

  const submit = async () => {
    if (!demand?.demand_id) { setError(t('clientReview.syncError')); return; }
    if (!rating) { setError(t('clientReview.ratingRequired')); return; }
    setBusy(true); setError('');
    try {
      await submitVerifiedReview({
        demandId: demand.demand_id,
        rating,
        comment: comment.trim(),
        dimensions: { clarity, responsiveness, payment_reliability: paymentReliability },
      });
      setBusy(false); close?.();
    } catch (e) {
      setError(e.message || t('clientReview.publishError'));
      setBusy(false);
    }
  };

  return (
    <Modal opened={show} close={() => !busy && close?.()}>
      <Header><div><span>{t('clientReview.verifiedProject')}</span><h2>{t('clientReview.title')}</h2><p>{getClientName(demand)}</p></div><button type="button" onClick={close}>×</button></Header>
      <Global><strong>{t('clientReview.overall')}</strong><ReactStars count={5} value={rating} onChange={setRating} size={34} activeColor="#c0a375" /></Global>
      <Grid>
        <Item><span>{t('clientReview.clarity')}</span><small>{t('clientReview.clarityHint')}</small><ReactStars count={5} value={clarity} onChange={setClarity} size={22} activeColor="#c0a375" /></Item>
        <Item><span>{t('clientReview.responsiveness')}</span><small>{t('clientReview.responsivenessHint')}</small><ReactStars count={5} value={responsiveness} onChange={setResponsiveness} size={22} activeColor="#c0a375" /></Item>
        <Item><span>{t('clientReview.payment')}</span><small>{t('clientReview.paymentHint')}</small><ReactStars count={5} value={paymentReliability} onChange={setPaymentReliability} size={22} activeColor="#c0a375" /></Item>
      </Grid>
      <Field><label htmlFor="artisan-client-review">{t('clientReview.optionalComment')}</label><textarea id="artisan-client-review" maxLength={1000} value={comment} onChange={(e)=>setComment(e.target.value)} /></Field>
      <Notice>{t('clientReview.notice')}</Notice>
      {error && <Error>{error}</Error>}
      <Actions><button type="button" onClick={close} disabled={busy}>{t('common.cancel')}</button><button type="button" onClick={submit} disabled={busy}>{busy ? t('clientReview.publishing') : t('clientReview.publish')}</button></Actions>
    </Modal>
  );
};

const Header=styled.header`display:flex;justify-content:space-between;gap:1rem;span{color:#8d6c36;font-size:.7rem;font-weight:900;text-transform:uppercase;}h2{margin:.25rem 0;}p{margin:0;color:var(--color-textMuted);}button{width:2.4rem;height:2.4rem;border:0;border-radius:50%;font-size:1.5rem;}`;
const Global=styled.div`display:grid;justify-items:center;gap:.35rem;padding:1rem;border-radius:1rem;background:#fff8e9;`;
const Grid=styled.div`display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:.55rem;margin-top:1rem;@media(max-width:38rem){grid-template-columns:1fr;}`;
const Item=styled.div`padding:.7rem;border-radius:.8rem;background:#faf8f4;span{display:block;color:#5f5a52;font-size:.72rem;font-weight:800;}small{display:block;min-height:2.2rem;margin:.22rem 0;color:#81796f;font-size:.62rem;line-height:1.35;}`;
const Field=styled.div`display:grid;gap:.4rem;margin-top:1rem;label{font-size:.78rem;font-weight:800;}textarea{min-height:7rem;padding:.75rem;border:1px solid #ddd3c4;border-radius:.8rem;resize:vertical;}`;
const Notice=styled.p`margin:1rem 0 0;padding:.8rem;border-radius:.8rem;background:#f5f2ed;color:#665f56;font-size:.74rem;line-height:1.5;`;
const Error=styled.p`color:var(--color-errorRed);font-size:.76rem;`;
const Actions=styled.div`display:flex;justify-content:flex-end;gap:.6rem;margin-top:1rem;button{min-height:2.7rem;padding:.6rem .85rem;border:1px solid #ddd3c4;border-radius:999px;background:#fff;font:inherit;font-weight:800;}button:last-child{background:#111;color:#fff;border-color:#111;}@media(max-width:32rem){flex-direction:column-reverse;button{width:100%;}}`;

export default ReviewClientByArtisanModal;
